import { STAGE, resolveStage } from '@amzn/d2c-application-website-common';

export const getStage = (): STAGE => {
  return resolveStage('sojask');
};
